type ResetHandler = () => void | Promise<void>;

function createHandlerRegistry() {
  const handlers: ResetHandler[] = [];
  return {
    register(fn: ResetHandler): () => void {
      handlers.push(fn);
      return () => {
        const i = handlers.indexOf(fn);
        if (i >= 0) handlers.splice(i, 1);
      };
    },
    async run(): Promise<void> {
      for (const fn of handlers) {
        try {
          await fn();
        } catch {
          // Best-effort: un fallo en un módulo no bloquea el reset de otros.
        }
      }
    },
  };
}

// ─── Session reset (user change / logout) ───────────────────────────────────

const sessionReset = createHandlerRegistry();
export const registerSessionResetHandler = sessionReset.register;
export const runSessionResetHandlers = sessionReset.run;

// ─── Overlay reset (branch change + logout) ─────────────────────────────────

const overlayReset = createHandlerRegistry();
export const registerOverlayResetHandler = overlayReset.register;
export function runOverlayResetHandlers(): void {
  void overlayReset.run();
}

// ─── Organization reset (org switch; mismo usuario) ─────────────────────────

const organizationReset = createHandlerRegistry();
export const registerOrganizationResetHandler = organizationReset.register;
export function runOrganizationResetHandlers(): void {
  void organizationReset.run();
}

// ─── Session cache clear (logout only) ──────────────────────────────────────

const cacheClear = createHandlerRegistry();
export const registerSessionCacheClearHandler = cacheClear.register;
export function runSessionCacheClearHandlers(): void {
  void cacheClear.run();
}
